/**
 * Common Encryption scheme.
 *
 * @group DRM
 *
 * @beta
 */
export const CENC = 'cenc';
//# sourceMappingURL=CENC.js.map